import { Input, Table } from "antd";
import { useCallback, useEffect, useState } from "react";
import { Badge, Col, ListGroup, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ListadoPlanes } from "../../../Service/Service.Plan";
import Swal from "sweetalert2";
import { ProcedimientosNuevosBilling } from "../../../Service/Service.billing";
import { agregarProcedimientos, updateProcedimientoFactura } from "../../../redux/actions";
import { calcularMontosCobertura } from "../../../utils/copagoCalculo";

function ModalPlanes({ data }) {

    const dispatch = useDispatch();

    const procedimientos = useSelector((state) => state.facturaredux.procedimientos);

    const { show, handleClose, pacienteSeleccionado, pacienteSelectedDetails } = data;
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [listarPlanes, setListarPlanes] = useState([]);
    const [selectedPlanes, setSelectedPlanes] = useState([]);

    const onRowSelectionChangeNuevo = (selectedRowKeys, selectedRows) => {
        setSelectedPlanes(selectedRows);
    };    
    
    const rowSelectionNuevo = {
        onChange: onRowSelectionChangeNuevo
    };

    const columns = [
        {
            // Decia 'Promocion': copy-paste del modal de promociones. Esta es
            // la lista de PLANES.
            title: 'Plan',
            dataIndex: 'nombre',
            key: 'nombre',
            width: 300,
        },
        {
            title: 'Seguro/Entidad',
            dataIndex: ['Seguros', 'nombre'],
            key: 'Seguros.nombre',
            width: 200,
        },
    ];

    const fetchInitialData = useCallback(async () => {
        setLoading(true);
        // CONFIG-PLANES-SEGURO-31: para aplicar cobertura en una operación nueva
        // solo se ofrecen planes Activos.
        const planes = await ListadoPlanes({ estado: "Activo", seguro_id: pacienteSeleccionado.seguro_id });

        const filteredPlanes = (planes.data || []).filter(plan => plan.seguro_id === pacienteSeleccionado.seguro_id);

        const listado = filteredPlanes.map((item, index) => ({
            ...item,
            key: item.id_plan,
        }));


        setListarPlanes(listado);
        setLoading(false);
    }, [pacienteSeleccionado]);

    useEffect(() => {
        if (show)
            fetchInitialData();
    }, [fetchInitialData, show]);


    const handleAgregarPlanes = async () => {

        // COBERTURAS-SEGURO100-RUNTIME-FLOW-AUDIT-05: antes solo validaba > 1;
        // con 0 seleccionados, `selectedPlanes[0].detalles` lanzaba TypeError
        // -> catch generico -> el plan NO se aplicaba sin señal clara.
        if (selectedPlanes.length !== 1) {
            Swal.fire({
                icon: "warning",
                title: "Atención",
                text: "Debe seleccionar exactamente un plan de la lista.",
            });
            return;
        }

        setLoading(true);

        try {

            const procedimientodelPlan = selectedPlanes[0].detalles || [];

            const procedimientosActualizados = procedimientos.map( proc => {
                const encontradoPlan = procedimientodelPlan.find(p => p.id_tipo_examen === proc.idExamenTipo)
                if (encontradoPlan) {
                    // COBERTURAS-COPAGO-CALCULO-AUDIT-FIX-01: reparto DERIVADO de
                    // (copago, tarifa). El backend igual lo recalcula server-side.
                    const m = calcularMontosCobertura(encontradoPlan.tarifario?.precio, encontradoPlan.copago);
                    return {
                        ...proc,
                        precio: m.precioPaciente,
                        plan : { ...encontradoPlan, precio_paciente: m.precioPaciente, precio_empresa: m.precioEmpresa, precio: m.precioEmpresa }
                    }
                }

                return proc;
            })

            dispatch(updateProcedimientoFactura(procedimientosActualizados));
            handleClose();

        } catch (response) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Hubo un error al agregar el procedimiento",
            });

        } finally {
            setLoading(false);
        }
    };
    
    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Aplicar plan</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <Input
                                placeholder="Buscar por nombre"
                                className="me-2 flex-grow-1"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-primary mx-1 text-nowrap"
                                disabled={selectedPlanes.length <= 0}
                                onClick={handleAgregarPlanes}
                            >Agregar
                            </button>
                        </div>
                    </Col>

                </Row>

                <Row>
                    <Col>
                        <Table dataSource={listarPlanes}
                            rowSelection={rowSelectionNuevo}
                            scroll={{ x: "max-content", y: 300 }}
                            columns={columns}
                            size='small'
                            pagination={true}
                            loading={loading}                            
                            expandable={{
                                expandedRowRender: (record) => (
                                    record.detalles.length > 0 ? (
                                        <div>
                                            {
                                                <ListGroup as="ol" numbered>
                                                    {
                                                        record.detalles.map((detalle, index) => (
                                                            <ListGroup.Item
                                                                as="li"
                                                                variant="light"
                                                                className="d-flex justify-content-between align-items-start"
                                                            >
                                                                <div className="ms-2 me-auto">
                                                                    <div className="fw-bold">{detalle.ExamenTipo.codigo} : {detalle.ExamenTipo.descripcion}</div>
                                                                    P. Normal: ${detalle.tarifario.precio.toFixed(2)} <br />
                                                                    Copago: {detalle.copago}% <br />
                                                                    Paga Paciente: ${calcularMontosCobertura(detalle.tarifario.precio, detalle.copago).precioPaciente.toFixed(2)} <br />
                                                                    Paga Empresa: ${calcularMontosCobertura(detalle.tarifario.precio, detalle.copago).precioEmpresa.toFixed(2)}
                                                                </div>
                                                                <Badge bg="primary" pill>
                                                                    {detalle.ExamenTipo.categoria.Descripcion}
                                                                </Badge>
                                                            </ListGroup.Item>
                                                        ))
                                                    }
                                                </ListGroup>
                                            }

                                        </div>
                                    ) : (
                                        <p>No hay detalles que mostrar...</p>
                                    )
                                ),
                                rowExpandable: (record) => !!record.detalles,
                            }}
                        />
                    </Col>
                </Row>

            </Modal.Body>

        </Modal>
    )
}

export default ModalPlanes;